import React, { useEffect, useState } from "react";
import { RiErrorWarningLine } from "react-icons/ri";
import axios from "axios";
import moment from "moment";
import { BaseUrl } from "../../../../../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import {
} from "../../../../../../Redux/Actions/actions";
import { Typography, Stack, Skeleton } from "@mui/material";
import {
  ChatsCircle,
  Envelope,
  Eye,
  FacebookLogo,
  Phone,
  Robot,
  TwitterLogo,
  VideoCamera,
  WhatsappLogo,
} from "@phosphor-icons/react";

import SummeryComponent from "../../../Summery-component/SummeryComponent";

const mapStateToProps = (state) => {
  return {
    externalChatData: state.contactListData.externalChatData,
  };
};

const Interactiontab = (props) => {
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [showSummery, setShowSummery] = useState(false);
  const [sessionVal, setsessionVal] = useState([]);
  const [summerydata, setsummerydata] = useState();
  const [getsessionsbydate, setGetsessionsbydate] = useState(defaultValue);
  const [loader, setloader] = useState(false);

  const getSessionsDetails = async (value) => {
    setloader(true);
    await axios
      .post(
        BaseUrl + "/message/getSessions/",
        {
          email: props.selectedCustomer ? props.selectedCustomer.email : "",
          phonenumber: props.selectedCustomer
            ? props.selectedCustomer.phonenumber
            : "",
          date: value,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setsessionVal(res.data.data);
          setTimeout(() => {
            setloader(false);
          }, 2000);
        } else {
          setsessionVal([]);
          setTimeout(() => {
            setloader(false);
          }, 2000);
        }
      });
  };

  const handleShowDetails = async (session_id) => {
    const access_token = localStorage.getItem("access_token");
    let data = {
      sessionId: session_id,
    };
    await axios
      .post(BaseUrl + "/message/getSummery/", data, {
        headers: {
          Authorization: "Bearer " + access_token,
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((sessions) => {
        if (sessions.data.success) {
          setsummerydata(sessions.data.data);
          setShowSummery(true);
        } else {
          setsummerydata();
          setShowSummery(false);
        }
      })
      .catch((err) => {
        console.log("handleShowDetails", err);
      });
  };
  useEffect(() => {
    getSessionsDetails(defaultValue);
  }, []);

  return (
    <>
      <div
        className={props.InteractionHistorytab}
        id="pills-home"
        role="tabpanel"
        aria-labelledby="pills-home-tab"
      >
        <div className="d-flex justify-content-end m-2">
          <input
            type="Date"
            max={defaultValue}
            className="form-control form-control-sm"
            style={{
              cursor: "pointer",
              height: "10px",
              width: "120px",
            }}
            onChange={(e) => {
              getSessionsDetails(e.target.value);
              setGetsessionsbydate(e.target.value);
            }}
            value={getsessionsbydate}
          />
        </div>
        <div className="historynew m-2 CONTACT-LIST-AREA">
          {sessionVal.length > 0 ? (
            sessionVal.map((item) => {
              return (
                <div key={item.id} className="card-chat pt-2 pb-2 mb-2">
                  <div className="container">
                    <div className="row">
                      {loader ? (
                        <Skeleton
                          animation="wave"
                          variant="rectangular"
                          width={35}
                          height={35}
                          sx={{ borderRadius: "10px" }}
                        />
                      ) : (
                        <div className="col-md-2">
                          {item.channel == "webchat" ? (
                            <div
                              className="box d-flex align-items-center justify-content-center sms-bg"
                              style={{ boxShadow: "2px 3px 10px gray" }}
                            >
                              <ChatsCircle size={18} weight="bold" />
                            </div>
                          ) : item.channel == "from_whatsapp" ? (
                            <div
                              className="  box d-flex align-items-center justify-content-center what-bg"
                              style={{ boxShadow: "2px 3px 10px gray" }}
                            >
                              <WhatsappLogo size={18} weight="bold" />
                            </div>
                          ) : item.channel == "from_facebook" ? (
                            <div
                              className="  box d-flex align-items-center justify-content-center fb-bg"
                              style={{ boxShadow: "2px 3px 10px gray" }}
                            >
                              <FacebookLogo size={18} weight="bold" />
                            </div>
                          ) : item.channel == "from_twitter" ? (
                            <div
                              className="  box d-flex align-items-center justify-content-center twit-bg"
                              style={{ boxShadow: "2px 3px 10px gray" }}
                            >
                              <TwitterLogo size={18} weight="bold" />
                            </div>
                          ) : item.channel == "from_teams" ? (
                            <div
                              className="  box d-flex align-items-center justify-content-center teams-bg"
                              style={{ boxShadow: "2px 3px 10px gray" }}
                            >
                              <ChatsCircle size={18} weight="bold" />
                            </div>
                          ) : item.channel == "videochat" ? (
                            <div
                              className="  box d-flex align-items-center justify-content-center twit-bg"
                              style={{ boxShadow: "2px 3px 10px gray" }}
                            >
                              <VideoCamera size={18} weight="bold" />
                            </div>
                          ) : item.channel == "voice" ? (
                            <div
                              className="  box d-flex align-items-center justify-content-center twit-bg"
                              style={{ boxShadow: "2px 3px 10px gray" }}
                            >
                              <Phone size={18} weight="bold" />
                            </div>
                          ) : item.channel == "from_purple" ? (
                            <div
                              className="  box d-flex align-items-center justify-content-center twit-bg"
                              style={{ boxShadow: "2px 3px 10px gray" }}
                            >
                              <Robot size={18} weight="bold" />
                            </div>
                          ) : (
                            <div
                              className="  box d-flex  align-items-center justify-content-center call-bg"
                              style={{ boxShadow: "2px 3px 10px gray" }}
                            >
                              <Envelope size={18} weight="bold" />
                            </div>
                          )}
                        </div>
                      )}
                      <div className="col-md-10 d-flex ps-1 flex-wrap m-0 p-0 no-gutter">
                        <div className="box2 me-2 badge-bg d-flex align-items-center justify-content-center">
                          {loader ? (
                            <Skeleton
                              animation="wave"
                              variant="rectangular"
                              width={70}
                              height={10}
                              sx={{ borderRadius: "5px" }}
                            />
                          ) : (
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems={"center"}
                            >
                              <Typography
                                variant="subtitle1"
                                color="#1975D0"
                                sx={{ fontWeight: 600, fontSize: "9px" }}
                              >
                                Agent :
                              </Typography>

                              <p
                                className="mb-0 ms-1"
                                style={{ fontSize: "10px" }}
                              >
                                {item.agent?.username}
                              </p>
                            </Stack>
                          )}
                        </div>
                        <div className="box2 me-2 badge-bg d-flex align-items-center justify-content-center">
                          {loader ? (
                            <Skeleton
                              animation="wave"
                              variant="rectangular"
                              width={70}
                              height={10}
                              sx={{ borderRadius: "5px" }}
                            />
                          ) : (
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems={"center"}
                            >
                              <Typography
                                variant="subtitle1"
                                color="#1975D0"
                                sx={{ fontWeight: 600, fontSize: "9px" }}
                              >
                                Language :
                              </Typography>

                              <p
                                className="mb-0 ms-1"
                                style={{ fontSize: "10px" }}
                              >
                                {item.language}
                              </p>
                            </Stack>
                          )}
                        </div>
                        <div className="box2 me-2   badge-bg d-flex align-items-center justify-content-center">
                          {loader ? (
                            <Skeleton
                              animation="wave"
                              variant="rectangular"
                              width={70}
                              height={10}
                              sx={{ borderRadius: "5px" }}
                            />
                          ) : (
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems={"center"}
                            >
                              <Typography
                                variant="subtitle1"
                                color="#1975D0"
                                sx={{ fontWeight: 600, fontSize: "9px" }}
                              >
                                Date :
                              </Typography>

                              <p
                                className="mb-0 ms-1"
                                style={{ fontSize: "10px" }}
                              >
                                {moment(item.chat_started_at).format(
                                  "DD/MM/YYYY"
                                )}
                              </p>
                            </Stack>
                          )}
                        </div>
                        <div className="box2 me-2   badge-bg d-flex align-items-center justify-content-center">
                          {loader ? (
                            <Skeleton
                              animation="wave"
                              variant="rectangular"
                              width={70}
                              height={10}
                              sx={{ borderRadius: "5px" }}
                            />
                          ) : (
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems={"center"}
                            >
                              <Typography
                                variant="subtitle1"
                                color="#1975D0"
                                sx={{ fontWeight: 600, fontSize: "9px" }}
                              >
                                Skill :
                              </Typography>
                              <p
                                className="mb-0 ms-1"
                                style={{ fontSize: "10px" }}
                              >
                                {item.skillset ? item.skillset : "NA"}
                              </p>
                            </Stack>
                          )}
                        </div>
                     

                        <div className="box2 me-2   badge-bg d-flex align-items-center justify-content-center">
                          {loader ? (
                            <Skeleton
                              animation="wave"
                              variant="rectangular"
                              width={70}
                              height={10}
                              sx={{ borderRadius: "5px" }}
                            />
                          ) : (
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems={"center"}
                            >
                              <Typography
                                variant="subtitle1"
                                color="#1975D0"
                                sx={{ fontWeight: 600, fontSize: "9px" }}
                              >
                                Disposition :
                              </Typography>
                              <p
                                className="mb-0 ms-1"
                                style={{ fontSize: "10px" }}
                              >
                                {item.reason ? item.reason : "NA"}
                              </p>
                            </Stack>
                          )}
                        </div>
                        <div className="box2 me-2   badge-bg d-flex align-items-center justify-content-center">
                          {loader ? (
                            <Skeleton
                              animation="wave"
                              variant="rectangular"
                              width={70}
                              height={10}
                              sx={{ borderRadius: "5px" }}
                            />
                          ) : (
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems={"center"}
                            >
                              <Typography
                                variant="subtitle1"
                                color="#1975D0"
                                sx={{ fontWeight: 600, fontSize: "9px" }}
                              >
                                Time :
                              </Typography>
                              <p
                                className="mb-0 ms-1"
                                style={{ fontSize: "10px" }}
                              >
                                {item.chat_started_at
                                  ? moment(item.chat_started_at).format(
                                      "hh:mm:ss a"
                                    )
                                  : "--"}
                              </p>
                            </Stack>
                          )}
                        </div>

                        {item.channel == "voice" ? null : (
                          <>
                            {loader ? (
                              <Skeleton
                                animation="wave"
                                variant="rectangular"
                                width={30}
                                height={25}
                                sx={{ borderRadius: "5px" }}
                              />
                            ) : (
                              <div
                                className="box2 me-2 cursor-pointer badge-bg d-flex align-items-center justify-content-center"
                                onClick={() =>
                                  handleShowDetails(item.chat_session_id)
                                }
                              >
                                <strong className="change_font_size">
                                  <Eye
                                    size={14}
                                    weight="bold"
                                    cursor={"pointer"}
                                  />
                                </strong>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="d-flex justify-content-center">
              <div
                className="text-muted d-flex"
                style={{
                  flexDirection: "column",
                  marginTop: "20%",
                  width: "400px",
                  height: "100px",
                }}
              >
                <span className="mx-auto">
                  <RiErrorWarningLine size={30} />
                </span>
                <span className="mx-auto">
                  <h6 className="text-muted mt-2">
                    No Interaction History Found
                  </h6>
                </span>
              </div>
            </div>
          )}
        </div>
      </div>

      {showSummery && (
        <SummeryComponent
          OpenDialog={showSummery}
          summerydata={summerydata}
          handleClose={() => {
            setShowSummery(false);
          }}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, {
})(Interactiontab);
